"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textInputs = [
    'letters',
    'radio-input',
    'text',
    'textarea',
    'textarea-lf'
];
var ProfanityFilter = /** @class */ (function () {
    function ProfanityFilter(config) {
        this.config = config;
        this.loading = false;
        this.enabled = false;
        this.api = window[config.params.apiName];
        this.language = config.params.langBook;
        if (!this.api) {
            console.error("framily api not avilable: \"window." + this.config.params.apiName + "\"");
        }
        else if (!this.api.hasOwnProperty('checkProfanity')) {
            console.error("framily api method not avilable: \"window." + this.config.params.apiName + ".checkProfanity\"");
        }
        else {
            this.enabled = true;
        }
    }
    ProfanityFilter.prototype.checkForms = function (forms, book) {
        var _this = this;
        if (!this.enabled) {
            return Promise.resolve([]);
        }
        var profanityFilterSubjects = [];
        for (var _i = 0, forms_1 = forms; _i < forms_1.length; _i++) {
            var form = forms_1[_i];
            var _a = form.id.split('.'), prefix = _a[0], id = _a[1];
            var content = book.get(prefix, id);
            var customOption = form.options.findIndex(function (option) { return option.custom; });
            var hasCustomOption = customOption >= 0;
            var isCustomOption = customOption === form.value;
            if (!form.isDisabled() && (!hasCustomOption || isCustomOption) && content) {
                profanityFilterSubjects.push({
                    id: form.id,
                    content: book.get(prefix, id),
                    language: this.language
                });
            }
        }
        if (!profanityFilterSubjects.length) {
            return Promise.resolve([]);
        }
        this.loading = true;
        return new Promise(function (resolve) {
            _this.checkFilterSubjects(profanityFilterSubjects).then(function (profanityFilterResult) {
                _this.loading = false;
                resolve(profanityFilterResult);
            });
        });
    };
    ProfanityFilter.prototype.checkFilterSubjects = function (subjects) {
        return this.api.checkProfanity(subjects);
    };
    return ProfanityFilter;
}());
exports.ProfanityFilter = ProfanityFilter;
exports.default = angular.module('pb.profanity', [])
    .service('profanityFilter', ProfanityFilter);
